// extracted by mini-css-extract-plugin
export default {"warning":"ArchiveActionMenuLabel_warning__rL-X9","tooltip":"ArchiveActionMenuLabel_tooltip__qXHJP"};